import { Trial, ResponseStatus, ConfigurationTrial } from "@/api/dtos";
import { createContext } from "react"

export interface ISourceDataFormContext {
    updating: boolean;
    queueUpdate: () => Promise<void>;
}

export const SourceDataFormContext = createContext<ISourceDataFormContext>({
    updating: false,
    queueUpdate: () => {
        return new Promise<void>(res => {
            res();
        });
    }
});

export default SourceDataFormContext;